import '../modal/ModalBase.css';
import ModalOverlay from '../modal/ModalOverlay';
import ModalPortal from '../modal/ModalPortal';
import './ConfirmModal.css';

type Props = {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  submitting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmModal = ({
  title = 'Подтверждение',
  message,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  danger = false,
  submitting = false,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <ModalPortal>
    <ModalOverlay onClose={onCancel}>
      <div className="modal confirm-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <div className="modal-body">
          <p className="confirm-message">{message}</p>
        </div>
        <div className="modal-actions">
          <button
            type="button"
            className="btn-cancel"
            onClick={onCancel}
            disabled={submitting}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`btn-save${danger ? ' confirm-danger' : ''}`}
            onClick={onConfirm}
            disabled={submitting}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </ModalOverlay>
    </ModalPortal>
  );
};

export default ConfirmModal;
